module.exports = __webpack_public_path__ + "static/media/Logo App Dev.5f1099a3.svg";